import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../helpers/reselectHelpers';
import {SettingsDevelopersUrl} from '../../models/url/settingsUrlModel';
import {AppState} from '../../store/appState';
import {getFindIsExpanded} from '../../store/data/localPreferences/localPreferencesSelectors';
import {computeInfoBoxKeyFromUrl} from './helpers/developersInfoBoxHelpers';
import {SettingsDevelopersInfoBox} from './settingsDevelopersInfoBox';

/*
 * Constants.
 */

const isInfoBoxExpandedDefault = true;

/*
 * Props.
 */

interface SettingsDevelopersInfoBoxContainerProps {
  url: SettingsDevelopersUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsDevelopersInfoBoxContainerProps) {
  return props.url;
}

const getInfoBoxKey = createSelector(getUrl, (url) => computeInfoBoxKeyFromUrl(url));

const getIsInfoBoxExpanded = createSelector([getFindIsExpanded, getInfoBoxKey], (findIsExpanded, key) => {
  if (!key) {
    return false;
  }
  return findIsExpanded(key, isInfoBoxExpandedDefault);
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersInfoBoxContainerProps>()(() => ({
  isInfoBoxExpanded: getIsInfoBoxExpanded,
  infoBoxKey: getInfoBoxKey,
}));

export const SettingsDevelopersInfoBoxContainer = connect(mapStateToProps)(SettingsDevelopersInfoBox);
